import { render } from "./DocumentClassExportStatesSubView.vue?vue&type=template&id=f3194854&scoped=true&ts=true"
import script from "./DocumentClassExportStatesSubView.vue?vue&type=script&lang=ts"
export * from "./DocumentClassExportStatesSubView.vue?vue&type=script&lang=ts"

import "./DocumentClassExportStatesSubView.vue?vue&type=style&index=0&id=f3194854&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3194854"]])

export default __exports__